import React, { useState, useRef } from 'react';
import { Download, ChevronDown } from 'lucide-react';
import { useClickAway } from '../hooks/useClickAway';
import { COLORS } from '../lib/theme';
import type { FormData } from '../types/form';

interface DownloadMenuProps {
  onDownloadTxt: () => void;
  onDownloadDocx: () => void;
}

export function DownloadMenu({ onDownloadTxt, onDownloadDocx }: DownloadMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useClickAway(ref, () => setIsOpen(false));

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-6 py-3 rounded-full text-white transition-colors duration-200"
        style={{ backgroundColor: COLORS.primary }}
      >
        <Download className="w-5 h-5" />
        <span>Download</span>
        <ChevronDown className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 z-10">
          <button
            onClick={() => {
              onDownloadTxt();
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100"
          >
            Download as TXT
          </button>
          <button
            onClick={() => {
              onDownloadDocx();
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-gray-100"
          >
            Download as DOCX
          </button>
        </div>
      )}
    </div>
  );
}